export default "__VITE_ASSET__DySVrK6___"